import { environment } from '@/config/environment'
import { CypressContainer } from './CypressTestId.styled'

import type { ReactNode } from 'react'

type CypressTestIdProps = {
  children: ReactNode
  id: string
}

const CypressTestId = ({ children, id }: CypressTestIdProps) => {
  return environment.cypress ? <CypressContainer data-test-id={id}>{children}</CypressContainer> : <>{children}</>
}

export { CypressTestId }
